<template>
  <element-form
    v-if="element"
    :categories="categories"
    :costCenters="costCenters"
    :entities="entities"
    :inventoryDeletionCauses="inventoryDeletionCauses"
    :places="places"
    :element="element"
    :group="group"
    :selectedEntity="selectedEntity"
    :selectedPlace="selectedPlace"
    :admin="admin"
    :prevRoute="prevRoute"
    :removeFromGroup="removeFromGroup"
    :linkToGroup="linkToGroup"
  />
</template>

<script>
import ElementForm from "@/components/ElementForm";
import axios from "axios";

export default {
  props: [
    "categories",
    "costCenters",
    "entities",
    "inventoryDeletionCauses",
    "places",
    "admin"
  ],
  components: {
    ElementForm
  },
  data: () => ({
    element: undefined,
    group: undefined,
    prevRoute: ""
  }),
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData: async function() {
      const { params } = this.$route;
      const { _id } = params;
      try {
        const { data: element } = await axios({
          method: "get",
          url: `${process.env.VUE_APP_API_URI}/elements/${_id}`
        });
        this.element = element;
        if (element.group) {
          const { data: group } = await axios({
            method: "get",
            url: `${process.env.VUE_APP_API_URI}/groups/${element.group}`
          });
          this.group = group;
        }
      } catch (e) {
        console.log(e);
      }
    },
    linkToGroup: async function(value) {
      const parsed = JSON.parse(value);
      this.element.group = parsed.group;
      if (parsed.group !== "tmp-group-id") {
        const { data: group } = await axios({
          method: "get",
          url: `${process.env.VUE_APP_API_URI}/groups/${parsed.group}`
        });
        this.group = group;
      } else {
        this.group = {
          _id: "tmp-group-id",
          name: "",
          elements: [parsed.element],
          value: parsed.element.value
        };
      }
    },
    removeFromGroup: function() {
      this.element.group = null;
      this.group = undefined;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from.path;
    });
  },
  watch: {
    "$route.params._id": function() {
      this.fetchData();
    }
  },
  computed: {
    selectedEntity: function() {
      return this.entities && this.element.entity
        ? this.entities.find(e => e._id === this.element.entity)
        : { costCenter: { name: undefined } };
    },
    selectedPlace: function() {
      return this.places && this.element.place
        ? this.places.find(p => p._id === this.element.place)
        : { room: undefined, cabinet: undefined, name: undefined };
    }
  }
};
</script>